export let ChatEventType = /*#__PURE__*/ function (ChatEventType) {
    ChatEventType["UserPresenceChanged"] = "userPresenceChanged";
    ChatEventType["Message"] = "message";
    ChatEventType["UserTyping"] = "userTyping";
    ChatEventType["ConnectionStateChanged"] = "connectionStateChanged";
    ChatEventType["UserConnected"] = "userConnected";
    ChatEventType["UserDisconnected"] = "userDisconnected";
    return ChatEventType;
}({});
